import { render, staticRenderFns } from "./categorySlider.vue?vue&type=template&id=07a3fd8b"
import script from "./categorySlider.vue?vue&type=script&lang=js"
export * from "./categorySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports